export const SHOP_LIST = "cdb/shop/listnear";
export const QR_CODE = "cdb/cabinet/checkisok";
export const ZH_CODE = "cdb/cabinet/zhorder";

export const ORDER_TEMP = "cdb/cabinet/useBalanceToRent";
export const ORDER_CZ = "cdb/cabinet/order";
export const ORDER_CHECK = "cdb/cabinet/ordercheck";
